<template>
  <de-layout-content>
    <div class="">
      <a-button type="primary" class="margin-r10" icon="edit" @click="butClick(1)">
        审批用户
      </a-button>
      <!-- <a-button type="primary" @click="butClick(2)">
        <template #icon><SettingOutlined /></template>
        设置审批人
      </a-button> -->
    </div>
    <div class="mt10 mb10">
      <el-form :inline="true" :model="form" class="ant-advanced-search-form" size="small">
        <el-form-item label="姓名">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="组别名称">
          <el-input maxlength="11" v-model="form.phone" @input="onlyNumber($event, form, 'phone')" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="所在机构">
          <el-select v-model="form.organizationId" placeholder="请选择所在机构">
            <el-option :label="item.name" :value="item.id" :key="index" v-for="(item, index) in orgList"></el-option>
          </el-select>
        </el-form-item>
        <!-- <a-form-item label="姓名">
          <a-input v-model="form.name" placeholder="请输入姓名" />
        </a-form-item>
        <a-form-item label="手机号码">
          <a-input type="tel" @input="onlyNumber($event, form, 'phone')" :maxlength="11" v-model="form.phone"
            placeholder="请输入手机号码" />
        </a-form-item> -->
        <!-- <a-form-item label="用户类型">
          <a-select v-model="form.type" style="width: 150px;" placeholder="请选择用户类型">
            <a-select-option :value="null">全部</a-select-option>
            <a-select-option :value="1">管理员</a-select-option>
            <a-select-option :value="2">运动员</a-select-option>
            <a-select-option :value="3">教练员</a-select-option>
            <a-select-option :value="4">科研医疗人员</a-select-option>
            <a-select-option :value="5">队伍管理人员</a-select-option>
          </a-select>
        </a-form-item> -->
        <el-form-item label="审批状态">
          <el-select v-model="form.type" placeholder="请选择审批状态">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="管理员" :value="1"></el-option>
            <el-option label="运动员" :value="2"></el-option>
            <el-option label="教练员" :value="3"></el-option>
            <el-option label="科研医疗人员" :value="4"></el-option>
            <el-option label="队伍管理人员" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <!-- <a-form-item label="审批状态">
          <a-select v-model="form.approvalStatus" style="width: 150px;" placeholder="请选择审批状态" >
            <a-select-option :value="null">全部</a-select-option>
            <a-select-option :value="1">待审批</a-select-option>
            <a-select-option :value="2">审批通过</a-select-option>
            <a-select-option :value="3">审批不通过</a-select-option>
          </a-select>
        </a-form-item> -->
        <el-form-item label="审批状态">
          <el-select v-model="form.approvalStatus" placeholder="请选择审批状态">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="待审批" :value="1"></el-option>
            <el-option label="审批通过" :value="2"></el-option>
            <el-option label="审批不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>

        <!-- <a-form-item label="注册时间">
          <a-range-picker v-model="form.time" />
        </a-form-item> -->
        <!-- <a-form-item>
          <a-button class="mr10" type="primary" icon="search" @click="btnOperation('search')"> 查询 </a-button>
          <a-button @click="btnOperation('reload')" icon="reload"> 重置 </a-button>
        </a-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="btnOperation('search')" icon="el-icon-search">查询</el-button >
          <el-button type="" @click="btnOperation('reload')" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 数据列表 -->
    <el-table element-loading-text="加载中" :data="dataSource" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" fixed width="50" :selectable="checkboxSelect"></el-table-column>
      <el-table-column label="姓名" align="center" prop="name" width="150" />
      <el-table-column label="用户类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ userType[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column label="照片" align="center" prop="headImageUrl" width="160">
        <template slot-scope="scope">
          <el-image fit="contain" class="avatar" :src="scope.row.headImageUrl"
            :preview-src-list="[scope.row.headImageUrl]">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="手机号码" align="center" prop="phone" />
      <el-table-column label="籍贯" align="center" prop="nativePlace">
        <template slot-scope="scope">
          {{ getCityById(scope.row.nativePlace) }}
        </template>
      </el-table-column>
      <el-table-column label="性别" align="center" prop="sex">
        <template slot-scope="scope">
          {{ scope.row.sex == '1' ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column label="审批状态" align="center" prop="approvalStatus">
        <template slot-scope="scope">
          <template v-if="scope.row.approvalStatus == 1">
            <span style="color: #ff9900">●</span>&nbsp;待审批
          </template>
          <template v-if="scope.row.approvalStatus == 2">
            <span style="color: #19be6b">●</span>&nbsp;审核通过
          </template>
          <template v-if="scope.row.approvalStatus == 3">
            <span style="color: #f56c6c">●</span>&nbsp;审核不通过
          </template>
        </template>
      </el-table-column>
      <el-table-column label="年龄" align="center" prop="age" />
      <el-table-column label="身高(cm)" align="center" prop="height" />
      <el-table-column label="体重(kg)" align="center" prop="weight" />
      <el-table-column label="所在机构" align="center" prop="employerName" />
      <el-table-column label="注册时间" align="center" prop="createTime" width="200">
        <template slot-scope="scope">
          {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="small" plain type="primary" @click="toDetail(scope.row)">详情</el-button>
          <el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize" @pagination="_getList" />

    <!-- 审批用户 -->
    <el-dialog title="审批用户" :visible.sync="show" width="600px" append-to-body>
      <el-form ref="editForm" :model="editForm" size="mini" :rules="rules" label-width="120px">
        <el-form-item label="审批结果:" prop="approvalStatus">
          <el-radio-group v-model="editForm.approvalStatus">
            <el-radio label="2">审批通过</el-radio>
            <el-radio label="3">审批不通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="选择组别:" class="isRequired" v-if="editForm.approvalStatus != 3">
          <el-form-item label="" prop="teamId" class="mr20">
            <el-select v-model="editForm.teamId" placeholder="所属运动队" @change="change">
              <el-option v-for="item in teamData" :key="item.id" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="groupId">
            <el-select v-model="editForm.groupId" placeholder="所属组别" @change="$forceUpdate()">
              <el-option v-for="item in groupData" :disabled="!editForm.teamId" :key="item.id" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item label="填写原因:" prop="approvalDesc" v-else>
          <el-input :rows="4" type="textarea" maxlength="300" placeholder="请填写原因" show-word-limit
            v-model="editForm.approvalDesc" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </de-layout-content>
</template>

<script>
import { message, Modal } from "ant-design-vue";
import moment from "moment";

import axios from 'axios'
import * as API_Member from "@/api/train/member";
export default {
  data() {
    return {
      showTime: {
        format: "HH:mm:ss",
        defaultValue: [
          moment("00:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
        ],
      },
      citys: [],
      selectedRowKeys: [],
      teamData: [],
      groupData: [],
      orgList: [],
      form: {
        name: null,
        phone: null,
        type: null,
        approvalStatus: null,
        organizationId: undefined,
        time: null,
        pageNum: 1,
        pageSize: 10,
      },
      show: false, // 审批用户
      setShow: false, // 设置审批人
      sp: [{ value: "1" }],
      setForm: {
        a1: null,
      },
      editForm: {
        teamId: null,
        groupId: null,
        approvalDesc: null,
        approvalStatus: null,
      },
      rules: {
        teamId: [{ required: true, message: "请选择所属运动队", trigger: "change" },],
        groupId: [{ required: true, message: "请选择所属组别", trigger: "change" },],
        approvalDesc: [{ required: true, message: "请填写拒绝原因", trigger: "blue" },],
        approvalStatus: [{ required: true, message: "请选择审批结果", trigger: "change" },],
      },
      dataSource: [],
      userType: {
        1: "管理员",
        2: "运动员",
        3: "教练员",
        4: "科研医疗人员",
        5: "队伍管理人员",
      }
    };
  },
  methods: {
    moment,
    _getCitys() {
      let url = `administrativeArea.json`;
      axios.get(url, {}, false, true).then((res) => {
        console.log(res);
        this.citys = res.data || [];
      });
    },
    getOrgList() {
      API_Member.orgList({type: 2}).then((res) => {
        // console.log(res);
        this.orgList = res.data || []
      })
    },
    // 接口-成员列表
    _getList() {
      let params = {
        ...this.form,
        startTime: this.form.time && +this.form.time[0],
        endTime: this.form.time && +this.form.time[1],
      }
      API_Member.getMemberList(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          const { list, total } = res.data;
          this.dataSource = list;
          this.total = total;
        }
      })
    },
    // 获取运动队
    _getTeams() {
      API_Member.teamList().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.teamData = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            };
          });
        }
      });
    },
    getCityById(code, arr = this.citys) {
      const findItem = arr.find((item) =>
        JSON.stringify(item).includes(`"code":"${code}"`)
      );
      if (!findItem) return "";
      else if (findItem.code == code) {
        return findItem.name;
      } else {
        return findItem.name + '/' + this.getCityById(code, findItem.areaList);
      }
    },
    handleDel(e) {
      this.$confirm(`确定删除该数据吗？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this._del(e);
        })
        .catch(() => { });
    },
    // 获取运动组
    getGroups(teamId) {
      API_Member.groupList({ teamId }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.groupData = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            };
          });
        }
      });
    },
    // 删除
    _del(e) {
      const params = {
        ids: [e.id],
      };
      API_Member.memberDel(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          message.success("删除成功！");
          this.form.pageNum = 1;
          this._getList();
        }
      })
    },

    change(e) {
      // console.log(e);
      this.editForm.groupId = null;
      this.groupData = [];
      this.getGroups(e);
    },
    butClick(type) {
      if (type === 1) {
        // 审批用户
        if (!this.selectedRowKeys.length) {
          const h = this.$createElement;
          Modal.info({
            title: () => "操作提示",
            content: () => h("div", {}, [h("p", "未选择数据，请选择一条数据")]),
            centered: true,
            okText: "我知道了",
          });
        } else {
          this.show = true;
        }
      } else if (type === 2) {
        // 设置审批人
        this.setShow = true;
      }
    },
    handleSelectionChange(e) {
      console.log(e);
      this.selectedRowKeys = e.map((item) => {
        return item.id
      });
      console.log(this.selectedRowKeys);
    },
    checkboxSelect(row, rowIndex) {
      if (row.approvalStatus == "1") {
        return true; // 不禁用
      } else {
        return false; // 禁用
      }
    },
    onlyNumber(e, form, key) {
      form[key] = e.target.value.replace(/\D/g, "");
    },

    // 用户审批
    approvalUser(params) {
      API_Member.memberAudit(params).then(res => {
        console.log(res);
        if (res.code == 200) {
          message.success("操作成功！");
          this.$refs["editForm"].resetFields();
          this.show = false;
          this._getList();
        }
      })
    },

    //查询重置
    btnOperation(type) {
      switch (type) {
        case "search":
          this.form.pageNum = 1;
          this._getList();
          break;
        case "reload":
          this.form = {
            name: null,
            phone: null,
            type: null,
            approvalStatus: null,
            time: null,
            pageNum: 1,
            pageSize: 10,
          }
          this._getList(); //重新获取数据
          break;
      }
    },
    toDetail(item) {
      this.$router.push(`/sportCenter/audit/detail?id=${item.id}&type=${item.type}`);
    },
    submitForm() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          const params = {
            ids: this.selectedRowKeys,
            ...this.editForm,
          };
          if (params.approvalStatus == 2) {
            params.approvalDesc = ''
          } else {
            params.teamId = null
            params.groupId = null
          }
          this.approvalUser(params);
        } else {
          console.log("error submit!!");
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    }
  },
  created() {
    // 获取列表
    this._getList();
    // 获取城市列表
    this._getCitys();
    // 获取运动组数据
    this._getTeams();
    this.getOrgList() // 机构列表
  },
};
</script>
<style lang='less' scoped>
::v-deep .flex {
  .ant-form-item {
    margin-bottom: 0;
    margin-right: 10px;
  }
}
</style>
<style lang="less">
@import "/src/styles/common/common.less";

.avatar {
  width: 100px;
  height: 100px;
  line-height: 100px;
  background: #f3f3f3;
}
</style>
